import React from 'react';
import { HostedPaymentVendor } from '../../constants/HostedPaymentVendorConstants';
import ForteForm from './iFrame/ForteForm';
import PaymentusForm from './iFrame/PaymentusForm';
import AuthorizeNetForm from './iFrame/AuthorizeNetForm';
import SlimCDForm from './iFrame/SlimCDForm';

const IFrameManager = (props) => {
    const { paymentProviderID } = props;

    switch (paymentProviderID) {
        case HostedPaymentVendor.SlimCD:
            return <SlimCDForm {...props} />;
        case HostedPaymentVendor.Paymentus:
            return <PaymentusForm {...props} />;
        case HostedPaymentVendor.Forte:
            return <ForteForm {...props} />;
        case HostedPaymentVendor.AuthorizeNet:
            return <AuthorizeNetForm {...props} />;
        default:
            return <div>Unsupported Payment Provider</div>;
    }
};

export default IFrameManager;
